import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface CardProps {
  readonly children: ReactNode;
  readonly className?: string;
  readonly onClick?: () => void;
}

export function Card({ children, className, onClick }: CardProps) {
  if (onClick) {
    return (
      <button
        type="button"
        className={twMerge(
          "rounded-lg bg-secondary text-left shadow-sm",
          className,
        )}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }

  return (
    <div className={twMerge("rounded-lg bg-secondary shadow-sm", className)}>
      {children}
    </div>
  );
}

interface CardSectionProps {
  readonly children: ReactNode;
  readonly className?: string;
}

export function CardHeader({ children, className }: CardSectionProps) {
  return (
    <div className={twMerge("px-6 py-4 font-medium", className)}>
      {children}
    </div>
  );
}

export function CardBody({ children, className }: CardSectionProps) {
  return <div className={twMerge("px-6 py-4", className)}>{children}</div>;
}

export function CardFooter({ children, className }: CardSectionProps) {
  return <div className={twMerge("px-6 py-4", className)}>{children}</div>;
}
